import { render, staticRenderFns } from "./VolunteerSelections.vue?vue&type=template&id=59fbf99d&scoped=true&"
import script from "./VolunteerSelections.vue?vue&type=script&lang=js&"
export * from "./VolunteerSelections.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerSelections.vue?vue&type=style&index=0&id=59fbf99d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fbf99d",
  null
  
)

export default component.exports